export interface Offer {
  id: string;
  productId: string;
  productName: string;
  productSku: string;
  modelVersionId: string;
  modelVersionName: string;
  paymentFrequencyId: string;
  paymentFrequencyName: string;
  name: string;
  fullPrice: number;
  cashPrice: number | null;
  lateFeePolicyId: string | null;
  lateFeePolicyName: string | null;
  downPayment: number;
  installmentCount: number;
  installmentAmount: number;
  status: OfferStatus;
  interestRate: number;
}

export interface CreateOffer {
  productId: string;
  paymentFrequencyId: string;
  name: string;
  fullPrice: number;
  cashPrice: number;
  lateFeePolicyId: string | null;
  downPayment: number;
  installmentCount: number;
  installmentAmount: number;
  status: OfferStatus;
  interestRate: number;
}

export interface UpdateOffer {
  status: OfferStatus;
}

export enum OfferStatus {
  Draft = 1,
  Active = 2,
  Inactive = 3,
}
